var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE3\x82\xAB"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M26.496 5.69598H32.448C32.32 7.16798 32.192 9.34398 32.128 10.88C31.296 36.992 24.256 48.96 11.648 57.728L6.97601 53.952C9.02401 52.864 11.584 51.072 13.504 49.28C21.504 42.048 26.752 31.232 26.88 11.008C26.88 9.53598 26.752 7.16798 26.496 5.69598Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace",
    d: "M29.5 5C30 36 21.5 49 8 56.5",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Stroke 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill_2",
    d: "M54.72 19.008L51.072 17.152C49.984 17.344 48.768 17.472 47.04 17.472H15.424C12.928 17.472 10.304 17.344 8.06403 17.152V22.528C10.368 22.336 12.928 22.272 15.488 22.272H49.216C49.216 29.12 48.384 44.864 45.952 49.792C45.248 51.328 44.032 51.904 42.24 51.904C39.488 51.904 36.16 51.584 32.704 51.136L33.344 56.448C36.672 56.704 40.384 56.896 43.584 56.896C47.104 56.896 49.152 55.744 50.432 52.992C53.312 46.848 54.144 28.288 54.336 22.08C54.4 21.248 54.528 20.096 54.72 19.008Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace_2",
    d: "M7.5 20H52C51 41.5 49.6343 47.8227 48 51.5C46 56 40.5 54.5 32.5 54",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 7
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKa);
export default __webpack_public_path__ + "static/media/ka.9338909d8db49d4fce5e2e8fd7d63082.svg";
export { ForwardRef as ReactComponent };